const mainNavData = [
  {
    analytics: {
      event: 'Search Clicked',
    },
    label: 'Search',
    url: '/office-space-london',
  },
  {
    analytics: {
      event: 'Locations Clicked',
    },
    label: 'Locations',
    panelName: 'locations',
    url: '/office-space-london',
  },
  {
    analytics: {
      event: 'Guides Clicked',
    },
    label: 'Guides',
    panelName: 'guides',
    url: '/blog/help-guide',
  },
  {
    analytics: {
      event: 'List Your Space Clicked',
    },
    label: 'List Your Space',
    url: '/host',
  },
];

export default mainNavData;
